import { createSystem, defaultConfig, mergeConfigs } from '@chakra-ui/react'
import { config } from '@hivemq/ui-theme'

export const system = createSystem(
  defaultConfig,
  mergeConfigs(config, {
    theme: {
      semanticTokens: {
        colors: {
          workflow: {
            bg: { value: { base: '{white}', _dark: '{colors.secondary.900}' } },
            color: {
              value: {
                base: '{colors.secondary.900}',
                _dark: '{colors.secondary.50}',
              },
            },
            borderColor: { value: { base: '{white}', _dark: '{black}' } },
          },
        },
      },
    },
  }),
)
